import React, { useState, useEffect, useCallback } from 'react';
// import axios from 'axios'; // <-- 1. Ya no se importa axios
import api from './apiService'; // <-- 2. Importamos nuestro 'api'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faEdit } from '@fortawesome/free-solid-svg-icons';
import './Settings.css';

function Settings({ session }) { // <-- Destructurado para claridad
  const [settings, setSettings] = useState([]);
  const [editSetting, setEditSetting] = useState(null);
  const [newValue, setNewValue] = useState('');
  // const apiPort = ...; // <-- 3. Eliminado. 'apiService' maneja esto.

  const fetchSettings = useCallback(async () => {
    try {
      // 4. ¡Llamada a la API simplificada! Sin URL, sin headers.
      const response = await api.get('/api/settings');
      
      // 5. [BUG FIX] Mapeamos los datos de la API a lo que la UI espera
      const mappedSettings = response.data.map(setting => ({
        ...setting,
        label: setting.name, // La API envía 'name', la UI usa 'label'
        help: setting.description // La API envía 'description', la UI usa 'help'
      }));

      setSettings(mappedSettings);
    } catch (error) {
      console.error('Error fetching settings:', error);
    }
  }, []); // <-- 6. Dependencias simplificadas

  useEffect(() => {
    fetchSettings();
  }, [fetchSettings]); // <-- 7. Se llama a fetchSettings

  const handleEditSetting = async () => {
    if (!editSetting) return;
    
    try {
      // 8. ¡Llamada a la API simplificada!
      await api.put(
        `/api/settings/${editSetting.id}`, // URL del endpoint
        { value: newValue, id: editSetting.id } // Body/payload de la petición
        // No se necesitan headers.
      );
      
      setEditSetting(null);
      setNewValue('');
      fetchSettings(); // Volvemos a cargar los settings actualizados
    } catch (error) {
      console.error('Error updating setting:', error);
    }
  };

  return (
    <div className="settings-container">
      <div className="container">
        <div className="row">
          <div className="col">
            <div className="card">
              <div className="card-body">
                <h5 className="card-title">Configuración</h5>
                <p className="card-text">Aquí puede establecer el horario de apertura y cierre del supermercado en el cual el turnero opera, como así también opciones para el llamador.</p>
              </div>
            </div>
          </div>
        </div>

        <div className="row" style={{ paddingTop: "20px", marginBottom: "20px" }}>
          {/* 9. La UI (JSX) no necesita cambios gracias al mapeo */}
          {settings.map(setting => (
            <div className="col" key={setting.id}>
              <div className="card" style={{ minHeight: "250px" }}>
                <div className="card-body">
                  <h5 className="card-title">{setting.label}</h5>
                  <p className="card-text">{setting.value}</p>
                  <p className="card-help">{setting.help}</p>
                </div>
                <div className="card-footer">
                  <button className="btn btn-primary" onClick={() => { setEditSetting(setting); setNewValue(setting.value); }}>
                    Editar <FontAwesomeIcon icon={faEdit} />
                  </button>
                </div>
              </div>
            </div>
          ))}
        </div>

        {editSetting && (
          <div className="edit-setting">
            <h5>Editar {editSetting.label}</h5>
            <input
              type="text"
              value={newValue}
              onChange={(e) => setNewValue(e.target.value)}
            />
            <button className="btn btn-primary" onClick={handleEditSetting}>Guardar Cambios</button>
            <button className="btn btn-secondary" onClick={() => setEditSetting(null)}>Cancelar</button>
          </div>
        )}
      </div>
    </div>
  );
}

export default Settings;